import { makeGetCall, makePostCall, makeDeleteCall } from '../../../utils/helper';

/**
 * API helpers for quiz explanation documents (OnlyOffice-backed .docx files).
 * Routes live under /api/quiz-documents on the backend.
 */

/** Upload a .docx file (or create a blank document when file is omitted). */
export const createQuizDocument = ({ file = null, title = undefined } = {}) => {
  if (file) {
    const formData = new FormData();
    formData.append('file', file);
    if (title) formData.append('title', title);
    return makePostCall('/quiz-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  return makePostCall('/quiz-documents', { title: title || 'Explanation' });
};

/** Fetch the signed OnlyOffice editor config for a document. */
export const getQuizDocEditorConfig = (docId, { mode = 'edit', type = 'desktop' } = {}) => {
  return makeGetCall(`/quiz-documents/config/${docId}?mode=${mode}&type=${type}`);
};

/** Flush any open editor session content to disk (Command Service forcesave). */
export const forceSaveQuizDocument = (docId) => {
  return makePostCall(`/quiz-documents/${docId}/forcesave`, {});
};

/** Delete a document (file + row); questions referencing it are detached. */
export const deleteQuizDocument = (docId) => {
  return makeDeleteCall(`/quiz-documents/${docId}`);
};
